/**
 *
 * This file was automatically generated using build-models npm script and should not be edited
 *
 **/
export const CreateOpportunityTimelineSectionOutputJsonApiModel = {
  id: "",
  "opportunity-timeline-section": {
    jsonApi: "hasOne",
    type: "opportunity-timeline-sections",
  },
};
